module.exports = __webpack_public_path__ + "img/ʚɞ野猪哥哥.83fd5bfb.jpg";